import { IonInput } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';


import { BUTTON_VARIABLES } from '../../constants/ButtonVariables';
import { NumericFormat } from 'react-number-format';
import { RootState } from '../../models/RootState';
import './ExchBetSlip.scss';
import { Button, IconButton } from '@mui/material';
import { Add, Close, Remove } from '@mui/icons-material';
import { clearExchangeBets, exchangeBetOddsChange, removeExchangeBet, setBettingInprogress, setExchangeBetStake } from '../../store/exchBetSlip/exchBetSlipReducer';
import { BsData } from '../../models/ExchBetSlip';
import { EventData } from '../../models/EventData';
import { fetchEventInfo } from '../../store/exchangeSports/exchangeSportsAction';
import { fetchOpenBets } from '../../store/exchBetSlip/exchBetSlipAction';
import { getUserBalance } from '../../store/authActions';
import { getBetStatus as getBetStatusUtil, placeBet as placeBetUtil } from '../../utils/bettingUtils';
import { useTranslation } from '../../hooks/useTranslation';
import { UserDetails } from '../../models/UserDetails';
type StoreProps = {
  balance: number;
  exposure: number;
  bets: BsData[];
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  fetchEventInfo: (sportId: any, eventId: any, navigate: Function) => void;
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: 'ADD' | 'SET'
  ) => void;
  eventData: EventData;
  clearExchangeBets: () => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  bettingInprogress: boolean;
  setBettingInprogress: (val: boolean) => void;
  mobileView?: boolean;
  wallets: any;
  activeWallet: any;
  getUserBalance: () => void;
  dispatch: Function;
  userDetails: UserDetails;
  dynamicTextColors?: any;
};

const ExchBetslip: React.FC<StoreProps> = (props) => {
  const { t } = useTranslation();
  const {
    balance,
    exposure,
    bets,
    eventData,
    exchangeBetOddsChange,
    removeExchangeBet,
    setExchangeBetStake,
    fetchEventInfo,
    clearExchangeBets,
    fetchOpenBets,
    bettingInprogress,
    setBettingInprogress,
    wallets,
    activeWallet,
    getUserBalance,
    dispatch,
    userDetails,
    dynamicTextColors
  } = props;

  // Get dynamic text color classes from Redux instead of calling function
  const accordionHeaderTextColorClass = dynamicTextColors?.accordionHeaderTextColorClass || '';
  const profitLossTextColorClass = dynamicTextColors?.backgroundCardTextColorClass || '';
  
  // betCardTextColorClass and inputTextColorClass both use --ion-background-color (same as accordionHeaderTextColorClass)
  const betCardTextColorClass = accordionHeaderTextColorClass;
  const inputTextColorClass = accordionHeaderTextColorClass;

  const navigate = useNavigate();

  const betPlaceHandler = async () => {
    let data = bets[0];
    return await placeBet(data, getBetStatus);
  };

  const placeBet = async (data: BsData, getBetStatusCallback?: Function) => {
    return await placeBetUtil(data, dispatch, getBetStatusCallback, navigate);
  };

  const onChangeOddHandler = (
    index: any,
    data: BsData,
    control: number
  ) => {
    if (data.oddValue === 1) {
      return false;
    }

    let value;
    if (control === 1) {
      let inc;
      if (data.oddValue < 2) inc = 0.01;
      else if (data.oddValue >= 2 && data.oddValue < 3) inc = 0.02;
      else if (data.oddValue >= 3 && data.oddValue < 4) inc = 0.05;
      else if (data.oddValue >= 4 && data.oddValue < 6) inc = 0.1;
      else if (data.oddValue >= 6 && data.oddValue < 10) inc = 0.2;
      else if (data.oddValue >= 10 && data.oddValue < 20) inc = 0.5;
      else if (data.oddValue >= 20 && data.oddValue < 30) inc = 1;
      else if (data.oddValue >= 30 && data.oddValue < 50) inc = 2;
      else if (data.oddValue >= 50 && data.oddValue < 100) inc = 5;
      else if (data.oddValue >= 100 && data.oddValue < 1000) inc = 10;
      else inc = 10;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue + inc).toFixed(2)
          : data.oddValue.toFixed(2);
    } else {
      let inc;
      if (data.oddValue <= 2) inc = 0.01;
      else if (data.oddValue > 2 && data.oddValue <= 3) inc = 0.02;
      else if (data.oddValue > 3 && data.oddValue <= 4) inc = 0.05;
      else if (data.oddValue > 4 && data.oddValue <= 6) inc = 0.1;
      else if (data.oddValue > 6 && data.oddValue <= 10) inc = 0.2;
      else if (data.oddValue > 10 && data.oddValue <= 20) inc = 0.5;
      else if (data.oddValue > 20 && data.oddValue <= 30) inc = 1;
      else if (data.oddValue > 30 && data.oddValue <= 50) inc = 2;
      else if (data.oddValue > 50 && data.oddValue <= 100) inc = 5;
      else if (data.oddValue > 100 && data.oddValue <= 1000) inc = 10;
      else inc = 10;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue - inc).toFixed(2)
          : data.oddValue.toFixed(2);
    }

    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const allInStake = (index: number) => {
    let amount = 0;
    const matchingWallet = wallets.find(
      (wallet: any) => wallet?.walletName === "POINTS"
    );
    if (matchingWallet) {
      amount = Math.floor(matchingWallet?.balance - matchingWallet?.exposure);
    }
    setExchangeBetStake(index, amount, 'SET');
  }

  const getBetStatus = async (data: BsData) => {
    await getBetStatusUtil(data, dispatch, navigate);
  };

  return (
    <div className="exch-betslip-ctn">
      {bettingInprogress ? (
        <div className="betslip-progress">
          <div className="centered">
            <div className="spinner loading"></div>
          </div>
        </div>
      ) : null}

      {bets && bets.length > 0
        ? bets.map((data, index) => (
          <div
            className={
              data.betType === 'BACK'
                ? 'body-ctn bs-back-bet bet-body-back  back-line'
                : 'body-ctn bet-body-lay bs-lay-bet  lay-line'
            }
          >
            <div
              key={index}
              className={
                data.betType === 'BACK'
                  ? 'bet-body bet-body-back'
                  : 'bet-body bet-body-lay'
              }
            >
              <div className="header-row">
                <div className="header-event-market-div">
                  <div className={`event ${betCardTextColorClass}`}>{data.eventName}</div>
                  <div className={`market ${betCardTextColorClass}`}>
                    {data.marketType === 'MATCH_ODDS' ? (
                      <>
                        {data.marketName} @{' '}
                        <span className="odd-value">{data.runnerName}</span>
                      </>
                    ) : data?.marketType === 'FANCY' ? (
                      <>
                        {data?.marketName} {data?.sessionOutcome}
                      </>
                    ) : (
                      <>
                        {data.sessionOutcome} @{' '}
                        <span className="odd-value">
                          {data.oddValue}
                        </span>
                      </>
                    )}
                  </div>
                </div>

                <IconButton
                  aria-label="close"
                  className="bet-del-btn"
                  disabled={bettingInprogress}
                  onClick={() => removeExchangeBet(index)}
                >
                  <Close className="close-icon" />
                </IconButton>
              </div>
              <div
                className={
                  data.betType === 'BACK'
                    ? 'bet-card bet-card-back'
                    : 'bet-card'
                }
              >
                <div className="input-row">
                  <div className="input-row-ctn odds-ctn">
                    <div className={`row-header ${betCardTextColorClass}`}>
                      {t("sports.oddValue")}
                    </div>
                    <div className={`row-input ${inputTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                      <Button
                        variant="contained"
                        color="primary"
                        className="odds-btns"
                        startIcon={<Remove />}
                        onClick={() => onChangeOddHandler(index, data, 0)}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                      ></Button>
                      <IonInput
                        type="number"
                        value={data.oddValue
                        }
                        min="1"
                        mode="md"
                        step="0"
                        debounce={500}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                        className={inputTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}
                        style={{ color: inputTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                        onIonChange={(e) =>
                          exchangeBetOddsChange(
                            index,
                            parseFloat(e.detail.value ?? "0")
                          )
                        }
                      ></IonInput>

                      <Button
                        variant="contained"
                        color="primary"
                        className="odds-btns"
                        startIcon={<Add />}
                        onClick={() => onChangeOddHandler(index, data, 1)}
                        disabled={
                          bettingInprogress || data.marketType !== 'MATCH_ODDS'
                        }
                      ></Button>
                    </div>
                  </div>
                  <div className="input-row-ctn stake-ctn">
                    <div className={`row-header ${betCardTextColorClass}`}>{t("common.amount")}</div>
                    <div className="bg-[var(--ion-background-color)] rounded-full">
                      <NumericFormat
                        value={data.stakeAmount}
                        thousandSeparator={true}
                        thousandsGroupStyle="lakh"
                        className={`row-input ${inputTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        allowNegative={false}
                        disabled={bettingInprogress}
                        onValueChange={(val: any) => {
                          setExchangeBetStake(index, val.floatValue, 'SET');
                        }}
                        style={{
                          height: '39px',
                          border: 0,
                          padding: '10px',
                          color: inputTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF',
                          // maxWidth: '100px',
                        }}
                      />
                      <div className="clear-row">
                        <span
                          className={
                            bettingInprogress
                              ? `disabled text b-text ${betCardTextColorClass}`
                              : `text b-text ${betCardTextColorClass}`
                          }
                          onClick={() => {
                            if (!bettingInprogress) {
                              setExchangeBetStake(index, 0, 'SET');
                            }
                          }}
                        >
                          {t("sports.clear")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="quick-bet">
                  {BUTTON_VARIABLES.map((bV, idx) => (
                    <Button
                      key={'qb-btn' + idx}
                      className={`qb-btn ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                      disabled={bettingInprogress}
                      onClick={() =>
                        setExchangeBetStake(index, bV.stake, 'ADD')
                      }
                      style={{ color: betCardTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                    >
                      +{bV.label}
                    </Button>
                  ))}

                  {data.marketType !== 'PREMIUM' && (
                    <>
                      <Button
                        key={'qb-btn-' + index}
                        className={`qb-btn-allin ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        disabled={bettingInprogress}
                        onClick={() =>
                          allInStake(index)
                        }
                        style={{ color: betCardTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                      >
                        {t("sports.allIn")}
                      </Button>
                      <Button
                        key={'qb-btn--' + index}
                        className={`qb-btn-allin ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        disabled={bettingInprogress}
                        onClick={() =>
                          setExchangeBetStake(index, data.maxLimit, 'SET')
                        }
                        style={{ color: betCardTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                      >
                        {t("sports.max")}
                      </Button>
                    </>
                  )}
                </div>
                <div className="d-flex-row">
                  <div className="width-mob-100">
                    <div className="profit-loss">
                      <div className={`info ${profitLossTextColorClass} ${profitLossTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: profitLossTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                        {t("sports.yourProfitLossAsPerPlacedBet")}
                      </div>
                      <div className="returns">
                        <div className={`amt ${profitLossTextColorClass} ${profitLossTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: profitLossTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                          {data.marketType === 'MATCH_ODDS'
                            ? data.betType === 'BACK'
                              ? (data.stakeAmount * (data.oddValue - 1)).toFixed(2)
                              : data.stakeAmount.toFixed(2)
                            : data.marketType === 'BOOKMAKER'
                              ? data.betType === 'BACK'
                                ? (
                                  data.stakeAmount *
                                  ((data.oddValue + 100) / 100 - 1)
                                ).toFixed(2)
                                : data.stakeAmount.toFixed(2)
                              : data.marketType === 'PREMIUM'
                                ? (data.stakeAmount * (data.oddValue - 1)).toFixed(
                                  2
                                )
                                : data.betType === 'BACK'
                                  ? (
                                    data.stakeAmount *
                                    ((data.oddValue + 100) / 100 - 1)
                                  ) //size
                                    .toFixed(2)
                                  : data.stakeAmount.toFixed(2)}
                        </div>
                      </div>
                    </div>

                    {/* <div className="profit-loss-pts">
                      <div className="info">
                        <div className="profit-loss">
                          <div className="info">
                            {"Total Amount (in PTS)"}
                          </div>
                        </div>
                      </div>
                      <div className="returns">
                        <div className="amt">
                          {bets.reduce((a, v) => a + v.stakeAmount, 0).toFixed(2)}
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="place-section mob-view">
                    <Button
                      className={`place-btn ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                      disabled={bettingInprogress}
                      onClick={betPlaceHandler}
                    >
                      <div className={`btn-content ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                        <div className={`label ${betCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: betCardTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                          {t("sports.placeBet")}
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
        : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetSlip.bets,
    bettingInprogress: state.exchBetSlip.bettingInprogress,
    eventData: state.exchangeSports.eventInfo,
    wallets: state.userDetails?.wallets,
    activeWallet: state.userDetails?.activeWallet,
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange({ index, odds })),
    fetchEventInfo: (sportId: string, eventId: string, navigate: Function) => dispatch(fetchEventInfo(sportId, eventId, navigate)),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: 'ADD' | 'SET') =>
      dispatch(setExchangeBetStake({ index, amount, type })),
    clearExchangeBets: () => dispatch(clearExchangeBets({})),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    getUserBalance: () => dispatch(getUserBalance()),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    dispatch: dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchBetslip);